export const MESSAGES = {
  TITLE: 'Preview documents',
  DESCRIPTION: 'Please read through your signing documents now. Let us know if you have any questions or concerns.',
  PREVIEW_BUTTON: 'Preview'
}
